import { api } from "../services/index";

export function getRoles(query) {
  if (query?.missingPolicies) return api.get(`/roles?missingPolicies=true`);
  return api.get(`/roles`);
}

export function addRole(data) {
  return api.put(`/roles`, data);
}

export function getRole(roleID, query) {
  if (query?.missingPolicies)
    return api.get(`/roles/${roleID}?missingPolicies=true`);
  return api.get(`/roles/${roleID}`);
}

export function editRole(roleID, data) {
  return api.patch(`/roles/${roleID}`, data);
}

export function deleteRole(roleID) {
  return api.delete(`/roles/${roleID}`);
}

export function addRoleUser(roleID, data) {
  return api.post(`/roles/${roleID}/users/batch-add`, data);
}

export function deleteRoleUser(roleID, data) {
  return api.post(`/roles/${roleID}/users/batch-delete`, data);
}

export function addRoleGroup(roleID, data) {
  return api.post(`/roles/${roleID}/groups/batch-add`, data);
}

export function deleteRoleGroup(roleID, data) {
  return api.post(`/roles/${roleID}/groups/batch-delete`, data);
}

export function addRolePolicies(roleID, data) {
  return api.post(`/roles/${roleID}/policies/batch-add`, data);
}

export function deleteRolePolicies(roleID, data) {
  return api.post(`/roles/${roleID}/policies/batch-delete`, data);
}

export function getRolePolicies(roleID) {
  return api.get(`/roles/${roleID}/policies`);
}

export function getRoleUsers(roleID) {
  return api.get(`/roles/${roleID}/users`);
}

export function getRoleGroups(roleID) {
  return api.get(`/roles/${roleID}/groups`);
}

export function duplicateRole(roleID, data) {
  return api.post(`/roles/${roleID}`, data);
}
